import { useContext } from "react";
import Context from "./Context";

const useAuth = () => {
  const authContext = useContext<any>(Context);
  return authContext;
};

export default useAuth;
